import { render, staticRenderFns } from "./InicioTres.vue?vue&type=template&id=6eb6db5c&scoped=true"
import script from "./InicioTres.vue?vue&type=script&lang=js"
export * from "./InicioTres.vue?vue&type=script&lang=js"
import style0 from "./InicioTres.vue?vue&type=style&index=0&id=6eb6db5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6db5c",
  null
  
)

export default component.exports